import Admin from 'hive-admin/src/components/Admin';

import FieldTable, { InputCheckbox } from './FieldTable';
import { renderCurrency } from './SystemCountry';

import Types from '../modules/types';

const SHIPPING_PROVIDERS = Object.keys(
  Types.SHIPPING_PROVIDER_METHOD_MAP,
).reduce(
  (agr, provider) => {
    agr[provider] = {
      provider,
      methods: Types.SHIPPING_PROVIDER_METHOD_MAP[provider].map(method => ({
        method,
        label: Types.SHIPPING_METHOD_LABELS_MAP[method],
      })),
    };
    return agr;
  },
  {},
);

Admin.addToLibrary(
  'FieldFreeShipping',
  ({ shippingProvider, ...config }) => FieldTable.create({
    label: 'Free Shipping',
    table: { showHeader: false, rowKey: 'method', size: 'small' },
    prepareValueForInput: (value = {}) => (
      SHIPPING_PROVIDERS[shippingProvider]
      .methods
      .reduce(
        (agr, { method, label }) => {
          if (value && value[method]) {
            agr.push({ ...value[method], method, label });
          } else {
            agr.push({ method, label, supported: false, threshold: 0 });
          }
          return agr;
        },
        [],
      )
    ),
    prepareValueForForm: value => value.reduce(
      (agr, row) => {
        agr[row.method] = row;
        return agr;
      },
      {},
    ),
    columns: [{
      key: 'supported',
      align: 'center',
      width: '50px',
      fields: [{
        name: 'supported',
        ComponentInput: InputCheckbox,
        props: {
          size: 'small',
        },
      }],
    }, {
      key: 'label',
      getLabel: ({ label }) => label,
    }, {
      key: 'threshold',
      width: '160px',
      fields: [{
        name: 'threshold',
        props: {
          size: 'small',
          align: 'right',
          placeholder: 'Above',
        },
        getProps: ({ props }, { supported, threshold } = {}) => ({
          ...props,
          addonBefore: renderCurrency(),
          disabled: !supported,
          value: supported ? threshold : '',
        }),
      }],
    }],
    ...config,
  }),
);
